import { styled } from '@styledComponents';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import { BackgroundCloudImage } from '@components/BackgroundCloudImage';

export const StyledSectionWrapper = styled(Flex)`
  text-align: center;
  width: 100%;
`;

export const StyledBackgroundCloudImage = styled(BackgroundCloudImage)`
  text-align: center;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    background-position: 50% bottom;
    background-repeat: no-repeat;
    background-size: contain;
    padding-top: 20%;
    padding-bottom: 30%;
  }
`;

export const ColumnInfo = styled(Columns.Column)`
  max-width: 500px;
`;

export const StyledBox = styled(Flex)`
  margin: auto;
  flex-direction: column;
  width: 100%;
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    font-weight: 300;
    font-size: 56px;
    line-height: 68px;
  }
  .text-pairing-body {
  }
  .text-pairing-eyebrow {
    text-align: left;
    width: 100%;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      text-align: center;
      font-size: 40px;
      line-height: 46.88px;
    }
    .text-pairing-body {
      text-align: center;
    }
    .text-pairing-eyebrow {
      text-align: center;
    }
  }
`;

export const StyledColumnDesktop = styled(Columns.Column)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledBgDownColumn = styled(Flex)<{
  backgroundImage: string;
}>`
  ${themeMediaQuery('below_sm')} {
    background: no-repeat center bottom url(${(props) => cloudAssetUrl(props.backgroundImage, { optimization: 'none' })});
    background-size: 190% auto;
    padding-bottom: 166px;
  }
`;

export const StyledButtonBox = styled(Box)`
  width: 100%;
  text-align: left;
  ${themeMediaQuery('below_sm')} {
    text-align: center;
  }
`;

export const StyledButton = styled(GetStartedButton)`
  ${themeMediaQuery('below_sm')} {
    padding: 0 15px;
    height: 45px;
    line-height: 43px;
  }
`;
